import React from 'react';
import {
    HideGuidelineProductModalContainer,
    HideGuidelineProductModalSpin,
    ModalBody,
    ModalList,
    ModalNote,
    ModalText,
} from './HideGuidelineProductModal.styles';
import { Product } from '../../../../../../models/product/types';
import { hideLiveGuidelineProductAction } from '../../../../../../redux/actions/liveGuidelineActions';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/redux';
import { CloseIcon } from '../../../../../../styles/common.styles';
import ModalTitle from '../../../../../../components/common/modalTitle/ModalTitle';
import ModalFooter from '../../../../../../components/common/modalFooter/ModalFooter';

interface Props {
    isOpen: boolean;
    product: Product | null;
    liveGuidelineId: number;
    handleCancel: () => void;
    onSuccess: () => void;
}

const HideGuidelineProductModal: React.FC<Props> = ({
    isOpen,
    product,
    liveGuidelineId,
    handleCancel,
    onSuccess,
}) => {
    const dispatch = useAppDispatch();
    const { liveGuidelineReducer } = useAppSelector((state) => state);

    const onSubmit = async () => {
        if (!product?.productId) return;
        await dispatch(
            hideLiveGuidelineProductAction({
                liveGuidelineId,
                productId: product.productId,
            }),
        );
        onSuccess();
    };

    return (
        <HideGuidelineProductModalContainer
            open={isOpen}
            onCancel={handleCancel}
            footer={null}
            centered
            closeIcon={<CloseIcon />}
        >
            <HideGuidelineProductModalSpin size="large" spinning={liveGuidelineReducer.pending}>
                <ModalTitle title="Hide product from Live Guideline" icon="hide-guideline.svg"  />
                <ModalBody>
                    <ModalText>
                        Are you sure you want to hide <strong>{product?.productName}</strong>? This
                        will:
                    </ModalText>
                    <ModalList>
                        <li>Prevent the product from being displayed in this Live Guideline</li>
                        <li>Remove this product from any exports</li>
                        <li>
                            Remove this Live Guideline's tag from the product in any Projects,
                            Libraries or other Guidelines
                        </li>
                    </ModalList>
                    <ModalNote>
                        If you change your mind about this product later, you can restore it in the
                        Notifications tab.
                    </ModalNote>
                </ModalBody>
                <ModalFooter action="Hide product" cancel={handleCancel} submit={onSubmit} />
            </HideGuidelineProductModalSpin>
        </HideGuidelineProductModalContainer>
    );
};

export default HideGuidelineProductModal;
